import { authenticateUser } from './dataManager';


const SESSION_KEY = 'digital_id_session';
export const getCurrentUser = () => {
  const session = localStorage.getItem(SESSION_KEY);
  if (!session) return null;
  
  try {
    const sessionData = JSON.parse(session);
    const now = new Date().getTime();
    if (now > sessionData.expires) {
      logout();
      return null;
    }
    return sessionData.user;
  } catch (error) {
    console.error('Error getting current user:', error);
    logout();
    return null;
  }
};

export const setCurrentUser = (user) => {
  const expires = new Date().getTime() + (24 * 60 * 60 * 1000); // 24 hours
  const sessionData = {
    userId: user.id,
    user: user, // Store the entire user object
    expires: expires,
    loginTime: new Date().toISOString()
  };
  localStorage.setItem(SESSION_KEY, JSON.stringify(sessionData));
};

export const login = async (username, password) => {
  try {
    const user = await authenticateUser(username, password);
    if (user) {
      setCurrentUser(user);
      return user;
    }
    return null;
  } catch (error) {
    console.error('Login error:', error);
    return null;
  }
};

export const logout = () => {
  localStorage.removeItem(SESSION_KEY);
};

export const isAuthenticated = () => {
  return getCurrentUser() !== null;
};

export const hasPermission = (requiredRole) => {
  const user = getCurrentUser();
  if (!user) return false;
  
  const roleHierarchy = {
    'super_admin': 3,
    'admin': 2,
    'editor': 1,
    'user': 0
  };
  
  return roleHierarchy[user.role] >= roleHierarchy[requiredRole];
};

export const canManageUsers = () => {
  const user = getCurrentUser();
  return user && (user.role === 'super_admin' || user.role === 'admin');
};

export const canCreateCards = () => {
  const user = getCurrentUser();
  return user && user.status === 'active';
};

export const canEditCard = (card) => {
  const user = getCurrentUser();
  if (!user) return false;
  if (user.role === 'super_admin') return true;
  if (user.role === 'admin') return true;
  return card.created_by === user.id;
};

export const isSessionValid = () => {
  const session = localStorage.getItem(SESSION_KEY);
  if (!session) return false;
  
  try {
    const sessionData = JSON.parse(session);
    const now = new Date().getTime();
    return now < sessionData.expires;
  } catch (error) {
    return false;
  }
};

export const refreshSession = () => {
  const user = getCurrentUser();
  if (user) {
    setCurrentUser(user);
    return true;
  }
  return false;
};
